export function resolveTechLogRole({
  databaseRole,
  profileRole,
  user,
} = {}) {
  const candidates = [
    databaseRole,
    profileRole,
    user?.user_metadata?.role,
    user?.app_metadata?.role,
    user?.role,
  ];

  for (const candidate of candidates) {
    const role = String(candidate || '')
      .trim()
      .toLowerCase();

    if (role) {
      return role;
    }
  }

  return '';
}
